import { render, staticRenderFns } from "./BuildHomes.vue?vue&type=template&id=e55afbc2&"
import script from "./BuildHomes.vue?vue&type=script&lang=js&"
export * from "./BuildHomes.vue?vue&type=script&lang=js&"
import style0 from "./BuildHomes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports